import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from "@angular/core";
import {Device, Site} from "../../../domain/cloud-topology";
import {Subject} from "rxjs";
import {faCircle, faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import {SiteDeviceService} from "../../../services/site/site-device.service";
import {DENSTORE, FUELCELL, SOLAR} from "../../../domain/constants";
import {takeUntil} from "rxjs/operators";

@Component({
    selector: 'app-site-devices',
    templateUrl: './site-devices.component.html',
    styleUrls: ['./site-devices.component.scss'],
    standalone: false
})
export class SiteDevicesComponent implements OnChanges, OnDestroy{

  @Input() site: Site;
  @Input() devicesDirty: boolean;
  @Output() devicesDirtyChange = new EventEmitter<boolean>();
  activeIds: string[];
  storageDirty: boolean;
  solarDirty: boolean;
  otherDirty: boolean;
  storageEnabled: boolean;
  solarDevicesEnabled: boolean;
  otherDevicesEnabled: boolean;
  storageDevices: Device[];
  solarDevices: Device[];
  otherDevices: Device[];
  circle = faCircle;
  info = faInfoCircle;
  storageDeviceTitle: string[];
  solarDeviceTitle: string[];
  otherDeviceTitle: string[];
  private subject$: Subject<void>;
  constructor(private deviceService: SiteDeviceService) {
    this.subject$ = new Subject<void>();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.site && (changes['devicesDirty'] == undefined || changes['devicesDirty'].firstChange)) { // don't repull data if we are just detecting dirty flag.
      this.getDeviceData();
    }
  }

  getDeviceData(): void {
    this.activeIds = []; //Make tabs close so template can reload.
    this.storageEnabled = false;
    this.solarDevicesEnabled = false;
    this.otherDevicesEnabled = false;
    this.storageDirty = false;
    this.solarDirty = false;
    this.otherDirty = false;

    if (this.site) {
      this.deviceService.getDevices(this.site.id).pipe(takeUntil(this.subject$)).subscribe( devices => {
        this.storageDevices = [];
        this.solarDevices = [];
        this.otherDevices = [];
        this.storageDeviceTitle = [];
        this.solarDeviceTitle = [];
        this.otherDeviceTitle = [];
        for (const device of devices) {
          if (device.config.type == DENSTORE) {
            this.storageDevices.push(device);
            this.storageDeviceTitle.push(device.config["availablePower"] + ' kw/' + (+device.config["nameplateEnergy"]).toFixed(2) + 'kWh ' +device.config["batterySystem"]+ ' ');
          }

          if (device.config.type == SOLAR) {
            this.solarDevices.push(device);
            this.solarDeviceTitle.push(device.store.name);
          }

          if (device.config.type == FUELCELL) {
            this.otherDevices.push(device);
            this.otherDeviceTitle.push(device.store.name);
          }
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.subject$.next();
    this.subject$.complete();
  }

  toggleStoragePanel($event) {
    this.storageDirty = $event;
    if (!$event) {
      this.devicesDirtyChange.emit(false);
      this.getDeviceData();
    } else {
      this.devicesDirtyChange.emit(true);
    }
  }

  toggleSolarPanel($event) {
    this.solarDirty = $event;
    if (!$event) {
      this.devicesDirtyChange.emit(false);
      this.getDeviceData();
    } else {
      this.devicesDirtyChange.emit(true);
    }
  }

  toggleOtherPanel($event) {
    this.otherDirty = $event;
    if (!$event) {
      this.devicesDirtyChange.emit(false);
      this.getDeviceData();
    } else {
      this.devicesDirtyChange.emit(true);
    }
  }
}
